import React from "react";
import styles from "../../styles/game-shot-charts.widget.module.scss";
import classNames from "classnames";
import {observer} from "mobx-react";

export const GameShotChartWidgetSelectorPlayerDetails = observer(({selectedShot, isShallowShotMapView}) => {
  const {player, outcome, isGoalType} = selectedShot;
  const typeShotName = isShallowShotMapView && selectedShot.shortViewName ? selectedShot.shortViewName : outcome?.name;
  return (
    player ? <div className={classNames(styles.selector_player_details)}>
      <div className={classNames(styles.selector_player_name)}>{player.name}</div>
      <div className={classNames(styles.selector_player_shot_description, {[styles.is_goal]: isGoalType})}>{typeShotName}</div>
    </div> : null
  )
});